import { render, staticRenderFns } from "./BuildCastleDialog.vue?vue&type=template&id=b919eeec&scoped=true"
import script from "./BuildCastleDialog.vue?vue&type=script&lang=js"
export * from "./BuildCastleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b919eeec",
  null
  
)

export default component.exports